import React from "react"

import { LogoImage } from "~/components/LogoImage/LogoImage"
import { RouterLink } from "~/components/RouterLink/RouterLink"

import styles from "./index.module.css"

export const Logo = () => (
  <RouterLink activeClassName={styles.ActiveLogo} className={styles.Logo} href="/">
    <LogoImage />
  </RouterLink>
)
